import Tag from './tag/Tag';
import CategoriesItems from './categories/CategoriesItems';
import { useRouter } from 'next/router';
import { useState } from 'react';

const Sidebar = ({ postTag, postCategory }) => {
  // ===================== HOOKS
  const router = useRouter();

  // ===================== STATE
  const [mobileFilter, setMobileFilter] = useState(false);

  // ===================== EVENTS
  const handleCheckboxChange = (checkboxValues) => {
    if (checkboxValues) {
      router.push(
        {
          pathname: `/blogs/${checkboxValues}`,
        },
        undefined,
        { scroll: false }
      );
    } else {
      router.push(
        {
          pathname: `/blog`,
        },
        undefined,
        { scroll: false }
      );
    }
  };
  const handleTagChange = (selectedTag) => {
    if (selectedTag?.length > 0) {
      if (router?.query?.category) {
        router.push(
          {
            pathname: `/blogs/${router.query.category}`,
            query: { tag: selectedTag.join(',') },
          },
          undefined,
          { scroll: false }
        );
      } else {
        router.push(
          {
            pathname: `/blog`,
            query: { tag: selectedTag.join(',') },
          },
          undefined,
          { scroll: false }
        );
      }
    } else {
      if (router?.query?.category) {
        router.push(
          {
            pathname: `/blogs/${router.query.category}`,
          },
          undefined,
          { scroll: false }
        );
      } else {
        router.push(
          {
            pathname: `/blog`,
          },
          undefined,
          { scroll: false }
        );
      }
    }
  };
  const handleMobileFilter = () => {
    setMobileFilter(!mobileFilter);
  };

  return (
    <>
      <button
        onClick={handleMobileFilter}
        className="mobile-filter-bar dark:bg-jacarta-700 dark:border-jacarta-600 border lg:hidden flex w-full justify-between px-4 py-3 mb-8 mt-[54px]"
      >
        <div>Filters</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clipPath="url(#clip0_749_18136)">
            <path
              d="M14 2.66602V3.99935H13.3333L10 8.99935V14.666H6V8.99935L2.66667 3.99935H2V2.66602H14ZM4.26933 3.99935L7.33333 8.59535V13.3327H8.66667V8.59535L11.7307 3.99935H4.26933Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_749_18136">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <div
        className={`${
          mobileFilter ? 'block' : 'hidden'
        } lg:block min-w-[350px] px-[2px] lg:w-1/4 mb-10 js-collections-sidebar lg:overflow-auto lg:sticky lg:top-32 lg:mr-12 scrollbar-custom divide-y divide-jacarta-100 dark:divide-jacarta-600`}
      >
        <div>
          <h2 id="filters-collections-heading">
            <button
              className="accordion-button relative flex w-full items-center justify-between py-3 text-left font-display text-xl text-jacarta-700 dark:text-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filters-collections"
              aria-expanded="true"
              aria-controls="filters-collections"
            >
              <span>Categories</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="accordion-arrow h-5 w-5 shrink-0 fill-jacarta-700 transition-transform dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
              </svg>
            </button>
          </h2>
          <div
            id="filters-collections"
            className="mt-3 collapse show"
            aria-labelledby="filters-collections-heading"
          >
            {/*<Form />*/}
            <ul className="space-y-6 mb-8">
              <CategoriesItems
                categoryList={postCategory}
                onChange={handleCheckboxChange}
              />
            </ul>
          </div>
        </div>
        <div className="mt-4 pt-4">
          <h2 id="filters-categories-heading">
            <button
              className="accordion-button relative flex w-full items-center justify-between py-3 text-left font-display text-xl text-jacarta-700 dark:text-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filters-categories"
              aria-expanded="true"
              aria-controls="filters-categories"
            >
              <span>Tags</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={24}
                height={24}
                className="accordion-arrow h-5 w-5 shrink-0 fill-jacarta-700 transition-transform dark:fill-white"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
              </svg>
            </button>
          </h2>
          <div
            id="filters-categories"
            className="mt-3 collapse show"
            aria-labelledby="filters-categories-heading"
          >
            <ul className="flex flex-wrap items-center">
              <Tag tagList={postTag} handleChange={handleTagChange} />
            </ul>
          </div>
        </div>
        {/* Categories filter */}
      </div>
    </>
  );
};

export default Sidebar;
